var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'base-admintag-container',
    { disabled: _vm.disabled },
    ..._vm.additionalStyles,
  ],attrs:{"title":_vm.helpText},on:{"click":_vm.onClick}},[_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.textContent))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }